export default "__VITE_ASSET__COubFFsC__"